import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AdminLayout.css';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../siteadmin/AdminFooter';
import SideBar from '../siteadmin/SideBar';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <div className="vh-100">
        <AdminHeader />
        <div className="f f-1 f-columns h-100p">
          <div className="bg-red h-100p">
            <SideBar />
          </div>
          <div className="f-1 p-l">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/AdminLayout.js